import React from "react";
import { Col, Form, Row, Select } from "antd";
import styles from "./index.module.scss";
import { DropDown } from "../../../../../assets/icons";
import { AppliedStage } from "../../../../../types/model/saveOffer";
import { BasePriceModel } from "../../../../../types/model/price";
import { Option } from "./index";

interface SaveOfferApplicationRulesProps {
  cancelReasonList: Option[];
  basePriceList: BasePriceModel[];
  onAppliedBasePriceIdsChange: () => void;
}

export function SaveOfferApplicationRules({
  cancelReasonList,
  basePriceList,
  onAppliedBasePriceIdsChange,
}: SaveOfferApplicationRulesProps) {
  return (
    <>
      <div className={styles.subtitle}>
        <span>Application rules</span>
      </div>
      <Row gutter={32}>
        <Col span={12}>
          <Form.Item label="Apllied cancel reason" name="cancelReasonCode" rules={[{ required: true }]}>
            <Select
              allowClear
              optionFilterProp="label"
              getPopupContainer={(trigger) => trigger.parentNode}
              showArrow
              suffixIcon={<DropDown />}
              placeholder="Please select applied cancel reason"
              options={cancelReasonList}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Applied stage" name="appliedStages" rules={[{ required: true }]}>
            <Select
              allowClear
              optionFilterProp="label"
              getPopupContainer={(trigger) => trigger.parentNode}
              showArrow
              suffixIcon={<DropDown />}
              mode="multiple"
              placeholder="Please select applied stage"
              options={Object.values(AppliedStage).map((stage) => ({
                label: stage,
                value: stage,
              }))}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={32}>
        <Col span={24}>
          <Form.Item label="Applied base price" name="appliedBasePriceIds" rules={[{ required: true, type: "array" }]}>
            <Select
              allowClear
              optionFilterProp="label"
              getPopupContainer={(trigger) => trigger.parentNode}
              showArrow
              suffixIcon={<DropDown />}
              mode="multiple"
              placeholder="Please select applied base price"
              onChange={onAppliedBasePriceIdsChange}
              onDeselect={(e) => console.log("clear base price", e)}
              options={basePriceList.map(({ id, name }) => ({
                label: name,
                value: id,
              }))}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
}
